import { supabase } from "@/integrations/supabase/client";
import type { Session } from "@supabase/supabase-js";

// Resolves once Supabase auth has finished initializing (or a session arrives
// via magic-link / token refresh). Prevents premature redirects to /login.
export function waitForSession(timeoutMs = 15000): Promise<Session | null> {
  return new Promise((resolve) => {
    let done = false;
    let sub: { subscription: { unsubscribe: () => void } } | null = null;
    const finish = (s: Session | null) => {
      if (done) return;
      done = true;
      try { sub?.subscription.unsubscribe(); } catch { /* ignore */ }
      resolve(s);
    };
    const res = supabase.auth.onAuthStateChange((event, session) => {
      if (session) finish(session);
      else if (event === "INITIAL_SESSION") finish(null);
    });
    sub = res.data;
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) finish(data.session);
    });
    setTimeout(() => {
      // Final check before giving up - avoids false logout on slow connections.
      supabase.auth.getSession()
        .then(({ data }) => finish(data.session ?? null))
        .catch(() => finish(null));
    }, timeoutMs);
  });
}
